import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Policy from "@/pages/Policy";
import Faqs from "@/pages/Faqs";
import AppShell from "@/components/AppShell";
import DashboardRouter from "@/pages/dashboard/DashboardRouter";
import FileCase from "@/pages/dashboard/FileCase";
import CaseDetail from "@/pages/dashboard/CaseDetail";
import CasesList from "@/pages/dashboard/CasesList";
import AdminUsers from "@/pages/dashboard/AdminUsers";
import AdminNeutrals from "@/pages/dashboard/AdminNeutrals";
import AdminLeads from "@/pages/dashboard/AdminLeads";
import BusinessTeam from "@/pages/dashboard/BusinessTeam";
import BusinessBulkImport from "@/pages/dashboard/BusinessBulkImport";
import NeutralCourse from "@/pages/dashboard/NeutralCourse";
import Panel from "@/pages/Panel";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/faqs" element={<Faqs />} />
          <Route path="/privacy" element={<Policy docKey="privacy" />} />
          <Route path="/terms" element={<Policy docKey="terms" />} />
          <Route path="/user-agreement" element={<Policy docKey="user-agreement" />} />
          <Route path="/refund" element={<Policy docKey="terms" />} />
          <Route path="/rules" element={<Policy docKey="terms" />} />
          <Route path="/panel" element={<Panel />} />

          <Route path="/app" element={<Protected><AppShell /></Protected>}>
            <Route index element={<DashboardRouter />} />
            <Route path="cases" element={<CasesList />} />
            <Route path="cases/:id" element={<CaseDetail />} />
            <Route path="file" element={<FileCase />} />
            <Route path="team" element={<BusinessTeam />} />
            <Route path="bulk" element={<BusinessBulkImport />} />
            <Route path="course" element={<NeutralCourse />} />
            <Route path="admin/users" element={<AdminUsers />} />
            <Route path="admin/neutrals" element={<AdminNeutrals />} />
            <Route path="admin/leads" element={<AdminLeads />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
